import {GroupedData} from "../../../data-structures/group";
import FieldProto from "../../../fields3/proto/field-proto";
import TaskFields from "../task-fields";
import {FieldType} from "../../../fields3/field-type";
import {SEPARATOR} from "../../../gd-components/popover-menu/const";


export default function taskFields_structureDateFields(taskFields: TaskFields):GroupedData {


    const dateFields : FieldType[] = [FieldType.DATE, FieldType.DATE_AND_TIME]

    taskFields.initAllCustomFields()
    const dateCustomFields = _.filter(taskFields.customFields(), (field:FieldProto)=>{
        return dateFields.includes(field.type)
    })

    return [
        {
            value  : 'dates',
            label  : 'Dates',
            type   : 'system',
            items      : [
                taskFields.deadline,
                taskFields.scheduleDate,
                taskFields.startDate,
                taskFields.endDate,
                // taskFields.startEnd, - this is range (!)
                SEPARATOR,
                taskFields.latestActivityMoment,
                taskFields.momentClosed,
                taskFields.momentCreated
            ]
        },
        {
            value       : 'custom-fields', // DO NOT CALL IT 'custom'!!!!
            label       : 'Custom',
            type        : 'custom-fields',
            items       : dateCustomFields
        }
    ]

}